// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Action imports
import { addAutocompleterId, setAutocompleteListResults, setAutocompleteSelectedIndex, resetAutocompleter, focusAutocompleter, blurAutocompleter, setAutocompleteShouldBlur, selectResultByIndex, decrementSelectedIndex, incrementSelectedIndex, setAutocompleteCategoriesResults, setAutocompleteInputText, setAutocompleteShowResults, } from './autocompleter.actions';
// Constants
import { CATEGORY_ORDER } from 'SearchApp/ts/constants';
export const AUTOCOMPLETER_STATE_SLICE_KEY = 'autocompleter';
export const initialAutocompleterState = {
    blurred: true,
    categoriesResults: {},
    inputText: '',
    results: [],
    selectedIndex: -1,
    selectedResult: null,
    shouldBlur: true,
    showResults: false,
};
export const autocompleter = createReducer({}, on(addAutocompleterId, (state, { autocompleterId }) => {
    const next = { ...state };
    next[autocompleterId] = { ...initialAutocompleterState };
    return next;
}), on(setAutocompleteInputText, (state, { autocompleterId, inputText }) => {
    const next = { ...state };
    next[autocompleterId] = {
        ...next[autocompleterId],
        inputText,
    };
    return next;
}), on(setAutocompleteListResults, (state, { autocompleterId, results }) => {
    const next = { ...state };
    const hasResults = results.length > 0;
    next[autocompleterId] = {
        ...next[autocompleterId],
        results,
        selectedIndex: hasResults ? 0 : -1,
        showResults: hasResults,
    };
    return next;
}), on(setAutocompleteCategoriesResults, (state, { autocompleterId, results }) => {
    const next = { ...state };
    let flatResults = [];
    for (let i = 0; i < CATEGORY_ORDER.length; i += 1) {
        const typeResults = results[CATEGORY_ORDER[i]];
        if (typeResults !== undefined) {
            flatResults = flatResults.concat(typeResults);
        }
    }
    const hasResults = flatResults.length > 0;
    next[autocompleterId] = {
        ...next[autocompleterId],
        results: flatResults,
        categoriesResults: results,
        selectedIndex: hasResults ? 0 : -1,
        showResults: hasResults,
    };
    return next;
}), on(setAutocompleteSelectedIndex, (state, { autocompleterId, selectedIndex }) => {
    const next = { ...state };
    next[autocompleterId] = {
        ...next[autocompleterId],
        selectedIndex,
    };
    return next;
}), on(setAutocompleteShowResults, (state, { autocompleterId, showResults }) => {
    const next = { ...state };
    next[autocompleterId] = {
        ...next[autocompleterId],
        showResults,
    };
    return next;
}), on(resetAutocompleter, (state, { autocompleterId }) => {
    const next = { ...state };
    next[autocompleterId] = { ...initialAutocompleterState };
    return next;
}), on(focusAutocompleter, (state, { autocompleterId }) => {
    const next = { ...state };
    const hasResults = next[autocompleterId].results.length > 0;
    next[autocompleterId] = {
        ...next[autocompleterId],
        blurred: false,
        selectedIndex: hasResults ? 0 : -1,
        showResults: hasResults,
    };
    return next;
}), on(blurAutocompleter, (state, { autocompleterId }) => {
    const next = { ...state };
    next[autocompleterId] = {
        ...next[autocompleterId],
        blurred: true,
        selectedIndex: -1,
        showResults: false,
    };
    return next;
}), on(setAutocompleteShouldBlur, (state, { autocompleterId, shouldBlur }) => {
    const next = { ...state };
    next[autocompleterId] = {
        ...next[autocompleterId],
        shouldBlur,
    };
    return next;
}), on(selectResultByIndex, (state, { autocompleterId }) => {
    const next = { ...state };
    const { selectedIndex, results } = next[autocompleterId];
    if (selectedIndex === -1) {
        return next;
    }
    // All we need to do here is set `selectedResult`. When the BaseAutocompleteComponent detects this change,
    // it will output the result and then dispatch `resetAutocompleter`
    const selectedResult = results[selectedIndex];
    next[autocompleterId] = {
        ...next[autocompleterId],
        selectedResult,
    };
    return next;
}), on(decrementSelectedIndex, (state, { autocompleterId }) => {
    const next = { ...state };
    const { selectedIndex, results } = next[autocompleterId];
    let nextIndex = selectedIndex - 1;
    if (nextIndex < 0) {
        nextIndex = results.length - 1;
    }
    next[autocompleterId] = {
        ...next[autocompleterId],
        selectedIndex: nextIndex,
    };
    return next;
}), on(incrementSelectedIndex, (state, { autocompleterId }) => {
    const next = { ...state };
    const { selectedIndex, results } = next[autocompleterId];
    let nextIndex = selectedIndex + 1;
    if (nextIndex >= results.length) {
        nextIndex = 0;
    }
    next[autocompleterId] = {
        ...next[autocompleterId],
        selectedIndex: nextIndex,
    };
    return next;
}));
